const CONDICION_VENTA_HARDCODE = [
  {
    descripcionCondicionVenta: "CONTADO",
    condicionVentaContado: false,
    idCondicionVenta: 1,
  },
  {
    descripcionCondicionVenta: "CUENTA CORRIENTE",
    condicionVentaContado: false,
    idCondicionVenta: 2,
  },
  {
    descripcionCondicionVenta: "CTA CTE  SEMANAL (7+7)[R4]",
    condicionVentaContado: false,
    idCondicionVenta: 3,
  },
  {
    descripcionCondicionVenta: "CTA CTE QUINCENAL (15+15)[R4]",
    condicionVentaContado: false,
    idCondicionVenta: 4,
  },
  {
    descripcionCondicionVenta: "CTA CTE MENSUAL (30+40)[R4]",
    condicionVentaContado: false,
    idCondicionVenta: 5,
  },
  {
    descripcionCondicionVenta: "SALDO A FAVOR RIO IV",
    condicionVentaContado: false,
    idCondicionVenta: 6,
  },
  {
    descripcionCondicionVenta: "CTA CTE AGRO MAYORISTA [R4]",
    condicionVentaContado: false,
    idCondicionVenta: 7,
  },
  {
    descripcionCondicionVenta: "CTA CTE  SEMANAL (7+7)[ADELIA]",
    condicionVentaContado: false,
    idCondicionVenta: 8,
  },
  {
    descripcionCondicionVenta: "CTA CTE  SEMANAL (7+7)[GLOBAL]",
    condicionVentaContado: false,
    idCondicionVenta: 9,
  },
  {
    descripcionCondicionVenta: "CTA CTE AGRO MAYORISTA[ADELIA]",
    condicionVentaContado: false,
    idCondicionVenta: 10,
  },
  {
    descripcionCondicionVenta: "CTA CTE AGRO MAYORISTA[GLOBAL]",
    condicionVentaContado: false,
    idCondicionVenta: 11,
  },
  {
    descripcionCondicionVenta: "CTA CTE MENSUAL(30+40)[ADELIA]",
    condicionVentaContado: false,
    idCondicionVenta: 12,
  },
  {
    descripcionCondicionVenta: "CTA CTE MENSUAL(30+40)[GLOBAL]",
    condicionVentaContado: false,
    idCondicionVenta: 13,
  },
  {
    descripcionCondicionVenta: "CTA CTE QUINCENAL(15+15)[ADEL]",
    condicionVentaContado: false,
    idCondicionVenta: 14,
  },
  {
    descripcionCondicionVenta: "SALDO A FAVOR ADELIA MARIA",
    condicionVentaContado: false,
    idCondicionVenta: 15,
  },
];
const getCondVenta = async () => {
  return CONDICION_VENTA_HARDCODE;
};

const condicionesVenta = {
  getCondVenta,
};

export default condicionesVenta;
